// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.link__u53_l9gK4g{cursor:pointer}`, "",{"version":3,"sources":["webpack://./src/app/views/layout/views/search/components/results/components/feedback/searchResultsFeedback.module.scss"],"names":[],"mappings":"AAAA,kBACE,cAAA","sourcesContent":[".link {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `link__u53_l9gK4g`
};
export default ___CSS_LOADER_EXPORT___;
